module.exports = __webpack_public_path__ + "img/OSDi_positiv_RGB.6a7475ce.svg";